import { render, staticRenderFns } from "./UpgptLogin.vue?vue&type=template&id=f65e567c&scoped=true&lang=pug"
import script from "./UpgptLogin.vue?vue&type=script&lang=js"
export * from "./UpgptLogin.vue?vue&type=script&lang=js"
import style0 from "./UpgptLogin.vue?vue&type=style&index=0&id=f65e567c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65e567c",
  null
  
)

export default component.exports